import { configureStore } from '@reduxjs/toolkit';
import boxReducer from '@src/state/boxSlice';
import { setPremiumAccountTypeSource } from '@src/utils/premiumAnalytics';
import sessionReducer from '@src/state/sessionSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    box: boxReducer,
  },
});

setPremiumAccountTypeSource(() => {
  const { user, status } = store.getState().session;
  if (user) return user.isGuest ? 'guest' : 'account';
  return status === 'ready' ? 'anonymous' : 'unknown';
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
